

export const soraFeatures = {
    title: '選擇 Sora 2 的理由',
    sub: 'OpenAI 的 Sora 2 在 AI 影片生成領域取得突破。',
    items: [
      { num: '01', title: '進階物理模擬與真實運動', text: '極高物理精準與運動真實感，複雜場景中物件保持一致性。' },
      { num: '02', title: '雙模式生成：文字轉影片與圖片轉影片', text: '可從文字生成或將圖片轉為動態序列，保持畫面一致性。' },
      { num: '03', title: '彈性輸出與多比例', text: '最長 15 秒，直橫版皆可；高清渲染、平台最佳化。' },
      { num: '04', title: '精準創作控制與多樣風格', text: '精細控制場景、動作與風格：寫實、電影感或風格化皆可。' }
    ]
  };
